import { Helmet } from "react-helmet-async";
import HeroSection from "../components/HeroSection";
import BenefitsSection from "../components/BenefitsSection";

export default function HomePage() {
  return (
    <>
      <Helmet>
        <title>Nexalus Infotech | Complete ELV & ICT Turnkey Solutions</title>
        <meta
          name="description"
          content="Nexalus Infotech - Leading ELV & ICT Systems Integrator providing complete turnkey solutions from consultancy to deployment and maintenance in Ahmedabad, India."
        />
      </Helmet>
      <main>
        <HeroSection />
        <BenefitsSection />
      </main>
    </>
  );
}
